import linksthree from "../../../../services/linksthree";
import { WIZARD_DELAYS } from "../constants";
import { FullStepDependencies } from "./stepTypes";

type FinishedStepDependencies = FullStepDependencies;

export const showFinishedStep = async (deps: FinishedStepDependencies) => {
  const { addBotMessage, userId, updateUser, refreshToken } = deps;

  // Marca o onboarding como completo automaticamente
  if (userId) {
    try {
      const result = await linksthree.completeOnboarding(userId);
      if (result.success) {
        // Se o backend retornou um novo token, atualiza o JWT
        if (result.token) {
          console.log("✅ Atualizando JWT com onboarding_completed");
          const tokenUpdated = refreshToken(result.token);
          if (!tokenUpdated) {
            console.warn("⚠️ Falha ao atualizar token, usando fallback");
            // Fallback: atualiza apenas o estado local
            updateUser({ onboarding_completed: true });
          }
        } else {
          // Se não retornou token, atualiza apenas o estado local
          console.log(
            "ℹ️ Backend não retornou token, atualizando estado local",
          );
          updateUser({ onboarding_completed: true });
        }
      }
    } catch (error) {
      console.error("Erro ao marcar onboarding como completo:", error);
    }
  }

  setTimeout(() => {
    addBotMessage(
      "🎉 Parabéns! Seu perfil está completo e pronto para receber alunos!",
      { wizardType: "confirmation", delay: WIZARD_DELAYS.MEDIUM },
    );
  }, WIZARD_DELAYS.MEDIUM);

  setTimeout(() => {
    addBotMessage(
      "Você já pode:\n• Compartilhar seu link personalizado\n• Receber agendamentos\n• Gerenciar seus treinos",
      { wizardType: "info", delay: WIZARD_DELAYS.MEDIUM },
    );
  }, 2200);

  setTimeout(() => {
    addBotMessage("O que deseja fazer agora?", {
      wizardType: "question",
      delay: WIZARD_DELAYS.MEDIUM,
      actions: [
        {
          label: "Ver Meu Perfil",
          onClick: () => handleViewProfile(deps),
          variant: "primary",
        },
        {
          label: "Ir para Dashboard",
          onClick: () => handleGoToDashboard(deps),
          variant: "secondary",
        },
      ],
    });
  }, WIZARD_DELAYS.EXTRA_LONG);
};

const handleViewProfile = (deps: FinishedStepDependencies) => {
  const {
    userId,
    addUserMessage,
    clearState,
    markOnboardingCompleted,
    setIsOpen,
    conversationStartedRef,
  } = deps;

  addUserMessage("Ver Meu Perfil");

  setTimeout(() => {
    if (userId) markOnboardingCompleted(userId);
    clearState();
    setIsOpen(false);
    conversationStartedRef.current = false;
    // Redireciona e recarrega a página
    window.location.href = `/profile/${userId}`;
  }, 500);
};

const handleGoToDashboard = (deps: FinishedStepDependencies) => {
  const {
    userId,
    addUserMessage,
    clearState,
    markOnboardingCompleted,
    locationSearch,
    setIsOpen,
    conversationStartedRef,
  } = deps;

  addUserMessage("Ir para Dashboard");

  setTimeout(() => {
    if (userId) markOnboardingCompleted(userId);
    clearState();
    setIsOpen(false);
    conversationStartedRef.current = false;
    // Remove o parâmetro onboarding e recarrega
    const params = new URLSearchParams(locationSearch);
    params.delete("onboarding");
    const newSearch = params.toString();
    const newUrl = newSearch
      ? `${window.location.pathname}?${newSearch}`
      : window.location.pathname;
    window.location.href = newUrl;
  }, 500);
};
